import React from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="py-12 sm:py-24 px-4 sm:px-6 lg:px-8 bg-cream" data-id="element-235">
      <div className="max-w-5xl mx-auto" data-id="element-236">
        <FadeIn data-id="element-237">
          <div className="text-center mb-8 sm:mb-16" data-id="element-238">
            <h2 className="text-2xl sm:text-4xl font-bold text-charcoal mb-2 sm:mb-4" data-id="element-239">
              Mujeres Reales, Resultados Reales
            </h2>
            <p className="text-sm sm:text-lg text-charcoal-light" data-id="element-240">
              Únete a miles de mujeres que ya han recuperado el control de su
              cuerpo.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-4 sm:gap-8" data-id="element-241">
          <FadeIn delay={0.1} direction="up" data-id="element-242">
            <div className="bg-white p-5 sm:p-8 rounded-2xl shadow-md border border-sage/10 relative h-full flex flex-col" data-id="element-243">
              <Quote className="absolute top-4 right-4 sm:top-6 sm:right-6 w-8 h-8 sm:w-10 sm:h-10 text-sage/20" data-id="element-244" />
              <div className="flex gap-1 mb-3 sm:mb-6" data-id="element-245">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 sm:w-5 sm:h-5 fill-accent text-accent" data-id="element-246" />)}
              </div>
              <p className="text-sm sm:text-lg text-charcoal-light italic mb-4 sm:mb-8 flex-grow" data-id="element-247">
                "No dormía más de 3 horas seguidas por los sudores. En 10 días
                con el Protocolo, mi temperatura se reguló y perdí 3 kilos de
                pura inflamación. ¡He vuelto a la vida!"
              </p>
              <div className="pt-4 sm:pt-6 border-t border-cream-dark mt-auto" data-id="element-248">
                <div className="font-bold text-charcoal text-base sm:text-lg" data-id="element-249">
                  Marta R., 48 años
                </div>
                <div className="text-xs sm:text-sm text-sage-dark mb-1 sm:mb-2" data-id="element-250">
                  Madrid, España
                </div>
                <div className="inline-block bg-sage/10 text-sage-dark px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-medium" data-id="element-251">
                  Resultado: -5cm de cintura en 21 días
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} direction="up" data-id="element-252">
            <div className="bg-white p-5 sm:p-8 rounded-2xl shadow-md border border-sage/10 relative h-full flex flex-col" data-id="element-253">
              <Quote className="absolute top-4 right-4 sm:top-6 sm:right-6 w-8 h-8 sm:w-10 sm:h-10 text-sage/20" data-id="element-254" />
              <div className="flex gap-1 mb-3 sm:mb-6" data-id="element-255">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 sm:w-5 sm:h-5 fill-accent text-accent" data-id="element-256" />)}
              </div>
              <p className="text-sm sm:text-lg text-charcoal-light italic mb-4 sm:mb-8 flex-grow" data-id="element-257">
                "Pensé que mis ataques de ira eran permanentes. Mi familia lo
                agradece tanto como yo. La neblina mental desapareció al cuarto
                día."
              </p>
              <div className="pt-4 sm:pt-6 border-t border-cream-dark mt-auto" data-id="element-258">
                <div className="font-bold text-charcoal text-base sm:text-lg" data-id="element-259">
                  Laura G., 52 años
                </div>
                <div className="text-xs sm:text-sm text-sage-dark mb-1 sm:mb-2" data-id="element-260">
                  Miami, FL
                </div>
                <div className="inline-block bg-sage/10 text-sage-dark px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-medium" data-id="element-261">
                  Resultado: Energía estable todo el día
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}